import { buildContactIdLookupHooks, mapCustomFieldsToDromoFields } from 'bundles/crm/imports/helpers';
import { PROPERTY_FIELDS } from './fields';

import type { CustomField } from 'bundles/apex/custom_fields/types';

export const groupId = 'crm_properties';

const ownerHooks = buildContactIdLookupHooks(
  'Owner Contact ID',
  { idKey: 'ownerContactId', queryKey: 'ownerContact' },
);

export function getDromoImporterConfig(customFields: CustomField[]) {
  return {
    bulkRowHooks: [ownerHooks.bulkRowHook],
    fields: [...PROPERTY_FIELDS, ...mapCustomFieldsToDromoFields(customFields)],
    groupId,
    importerOptions: {
      parser: 'Backoffice::Importer::Providers::Dromo::Parsers::Properties',
    },
    importerType: 'crm',
    stepHooks: [ownerHooks.stepHook],
    title: 'Properties',
  };
}
